import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
    IRefPersonalRequest, 
    IRefPersonalListResponse,
    IRefPersonalDeleteResponse,
    IOpcionesVariablesRequest,
    IOpcionesVariablesResponse,
    IDeptoCiudadRequest,
    IDeptoCiudadResponse,
    IBaseResponse,
    IValidaCapturaNomTefRequest,
    IValidaCapturaNomTefResponse,
    IResponse,
    IValidacionResponse,
    IGuardarReferenciaRequest,
    IGuardarReferenciaResponse,
    IDetalleReferenciaResponse,
    ICampoTablaWhereRequest,
    ICampoTablaWhereResponse
} from '../interfaces/ref-personal';

@Injectable({
    providedIn: 'root'
})
export class RefPersonalService {
    private baseUrl = environment.apiNewBackBaseUrl;

    constructor(private http: HttpClient) { }

    getRefPersonalList(request: IRefPersonalRequest): Observable<IRefPersonalListResponse> {
        return this.http.post<IRefPersonalListResponse>(
            `${this.baseUrl}ReferenciasPers/cmspa_refpersList`,
            request
        );
    }

    // Método para crear una nueva referencia personal
    createRefPersonal(request: IRefPersonalRequest): Observable<IRefPersonalListResponse> {
        return this.http.post<IRefPersonalListResponse>(
            `${this.baseUrl}ReferenciasPers/cmspa_refpersList`,
            { ...request, iAccion: 1 }
        );
    }

    // Método para actualizar una referencia personal
    updateRefPersonal(request: IRefPersonalRequest): Observable<IRefPersonalListResponse> {
        return this.http.post<IRefPersonalListResponse>(
            `${this.baseUrl}ReferenciasPers/cmspa_refpersList`,
            { ...request, iAccion: 2 }
        );
    }

    // Método para eliminar una referencia personal
    deleteRefPersonal(request: IRefPersonalRequest): Observable<IRefPersonalDeleteResponse> {
        return this.http.post<IRefPersonalDeleteResponse>(
            `${this.baseUrl}ReferenciasPers/cmspa_refpersDelete`,
            { ...request, iAccion: 3 }
        );
    }

    // Método para obtener opciones variables (tipos de referencia y relación)
    getOpcionesVariables(request: IOpcionesVariablesRequest): Observable<IOpcionesVariablesResponse> {
        return this.http.post<IOpcionesVariablesResponse>(
            `${this.baseUrl}OpcionesSolicitud/GetOpcionesVariables`,
            request
        );
    }

    // Método para obtener departamentos y ciudades
    getDeptoCiudad(request: IDeptoCiudadRequest): Observable<IDeptoCiudadResponse> {
        return this.http.post<IDeptoCiudadResponse>(
            `${this.baseUrl}DeptoCiudad/GetDepto_Ciudad`,
            request
        );
    }

    validaCapturaNomTef(request: IValidaCapturaNomTefRequest): Observable<IResponse<IValidacionResponse[]>> {
        return this.http.post<IResponse<IValidacionResponse[]>>(`${this.baseUrl}Relaciones/ValidacapturaNomTef`, request);
    }

    guardarReferencia(request: IGuardarReferenciaRequest): Observable<IResponse<IGuardarReferenciaResponse[]>> {
        return this.http.post<IResponse<IGuardarReferenciaResponse[]>>(`${this.baseUrl}ReferenciasPers/cmspa_refpersAddUpd`, request);
    }

    obtenerDetalleReferencia(request: IRefPersonalRequest): Observable<IResponse<IDetalleReferenciaResponse[]>> {
        return this.http.post<IResponse<IDetalleReferenciaResponse[]>>(`${this.baseUrl}ReferenciasPers/cmspa_refpersListClte`, request);
    }

    getCampoTablaWhere(request: ICampoTablaWhereRequest): Observable<ICampoTablaWhereResponse> {
        return this.http.post<ICampoTablaWhereResponse>(
            `${this.baseUrl}CampoTablaWhere/GetCampoTablaWhere`,
            request
        );
    }
} 